/* eslint-disable func-names */

/* eslint-disable no-unused-expressions */

/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_MEDIA_URL, COMMON_HEADER_CONFIG} from "../config";

class MediaService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchMedia = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_MEDIA_URL}/uploads`,
        params: {
          limit: 100,
          page: 1,
          sort: "created_at DESC",
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getList = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_MEDIA_URL}/uploads`,
        params: {
          size: 100,
          page: 1,
          sort: "created_at DESC"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOne = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_MEDIA_URL}/uploads/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  update = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "POST",
        url: `${API_MEDIA_URL}/uploads/update`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteMedia = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "DELETE",
        url: `${API_MEDIA_URL}/uploads/delete`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: {ids: [id]}
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(id);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  uploadFile = (presignedPostData, file) =>
    new Promise((resolve, reject) => {
      const formData = new FormData();
      Object.keys(presignedPostData.fields).forEach((key) => {
        formData.append(key, presignedPostData.fields[key]);
      });

      // Actual file has to be appended last.
      formData.append("file", file);

      const xhr = new XMLHttpRequest();
      xhr.open("POST", presignedPostData.url, true);
      xhr.send(formData);
      xhr.onload = function (response) {
        this.status === 204 ? resolve("success") : reject(response);
      };
    });

  uploadUpdateFile = (presignedPostData, file) =>
    new Promise((resolve, reject) => {
      const formData = new FormData();
      Object.keys(presignedPostData.fields).forEach((key) => {
        formData.append(key, presignedPostData.fields[key]);
      });

      // Actual file has to be appended last.
      formData.append("file", file);

      const xhr = new XMLHttpRequest();
      xhr.open("POST", presignedPostData.url, true);
      xhr.send(formData);
      xhr.onload = function (response) {
        this.status === 204 ? resolve(response) : reject(response);
      };
    });

  preUpload = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_MEDIA_URL}/uploads/pre_up`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createUpload = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_MEDIA_URL}/uploads/create`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const mediaService = new MediaService();

export default mediaService;
